/** Strukturerede data (JSON-LD) – kun dansk version */
export const DA_GAME = {
  "@context": "https://schema.org",
  "@type": "Game",
  name: "Wørdle",
  alternateName: ["Dansk Wordle", "Wørdle.nu"],
  description:
    "Wørdle er et dansk ordspil baseret på Wordle. Gæt dagens fem-bogstavs danske ord på maksimalt seks forsøg. Nyt ord hver dag.",
  url: "https://wørdle.nu",
  gamePlatform: "Web",
  applicationCategory: "Game",
  genre: "Word Game",
  inLanguage: "da",
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "DKK",
  },
  creator: {
    "@type": "Organization",
    name: "Wørdle.nu",
    url: "https://wørdle.nu",
  },
  publisher: {
    "@type": "Organization",
    name: "Wørdle.nu",
    url: "https://wørdle.nu",
  },
  potentialAction: {
    "@type": "PlayGameAction",
    target: "https://wørdle.nu",
  },
};

export const DA_WEBSITE = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Wørdle.nu",
  alternateName: "Wørdle",
  url: "https://wørdle.nu",
  description:
    "Wørdle er det danske ordspil baseret på Wordle. Gæt dagens danske ord på 6 forsøg. Gratis og nyt ord hver dag.",
  inLanguage: "da",
  publisher: {
    "@type": "Organization",
    name: "Wørdle.nu",
    url: "https://wørdle.nu",
  },
};

export const DA_ORG = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Wørdle.nu",
  url: "https://wørdle.nu",
  logo: "https://wørdle.nu/w%C3%B8rdle-nu.webp",
  sameAs: [
    "https://facebook.com/wørdle.nu",
    "https://instagram.com/wørdle.nu",
    "https://tiktok.com/@wørdle.nu",
  ],
};

export const DA_FAQ = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "Hvad er Wørdle?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Wørdle er et dansk ordspil baseret på det populære engelske Wordle. Spillet udfordrer dig til at gætte et fem-bogstavs dansk ord på maksimalt seks forsøg. Hver dag præsenteres et nyt ord, hvilket giver alle spillere samme udfordring.",
      },
    },
    {
      "@type": "Question",
      name: "Hvordan spiller man Wørdle?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Skriv et dansk ord på 5 bogstaver og tryk enter. Grønne felter betyder korrekt placeret bogstav. Gule felter betyder bogstavet er i ordet men på forkert plads. Grå felter betyder bogstavet ikke er i ordet. Du har 6 forsøg.",
      },
    },
    {
      "@type": "Question",
      name: "Er Wørdle gratis?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Ja, Wørdle er helt gratis at spille. Du behøver ingen konto. Spillet kører direkte i din browser på computer og mobil.",
      },
    },
    {
      "@type": "Question",
      name: "Hvornår kommer der et nyt Wørdle-ord?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Der kommer et nyt ord hver dag. Alle spillere får det samme ord, så du kan sammenligne dine resultater med venner og familie.",
      },
    },
    {
      "@type": "Question",
      name: "Hvilke ord kan man gætte i Wørdle?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Wørdle accepterer gyldige danske fem-bogstavs ord fra en omfattende ordliste med substantiver, verber og adjektiver fra det danske sprog.",
      },
    },
  ],
};

export const DA_HOWTO = {
  "@context": "https://schema.org",
  "@type": "HowTo",
  name: "Sådan spiller du Wørdle",
  description:
    "Lær at spille Wørdle - det danske ordspil. Gæt dagens ord på 6 forsøg.",
  totalTime: "PT5M",
  step: [
    {
      "@type": "HowToStep",
      name: "Skriv et ord",
      text: "Skriv et dansk ord på 5 bogstaver med tastaturet og tryk enter.",
    },
    {
      "@type": "HowToStep",
      name: "Læs farverne",
      text: "Grøn = korrekt plads. Gul = forkert plads. Grå = ikke i ordet.",
    },
    {
      "@type": "HowToStep",
      name: "Gæt igen",
      text: "Brug farveledetrådene til at indsnævre dit næste gæt. Du har 6 forsøg i alt.",
    },
  ],
};
